import useSWR from 'swr';

import { SWR_GLOBAL_CONFIG } from '~/api/_constant';
import { request } from '~/api/_utils/request';
import { ApiPresentation } from '~/api/v1/presentations/all_index/get';
import { PresentationT } from '~/state/presentation';

const getPath = (id?: string | number) => `/v1/competitions/${id}/presentations`;

export async function apiGetV1CompetitionByIdPresentations(id?: string | number) {
  if (id == null) return [];
  const { presentations } = await request.GET<{ presentations: ApiPresentation[] }>(getPath(id));
  return presentations;
}

export function useSWRV1CompetitionByIdPresentations(id?: string | number) {
  const swr = useSWR(
    getPath(id),
    () => apiGetV1CompetitionByIdPresentations(id),
    SWR_GLOBAL_CONFIG,
  );
  const presentations = swr.data;
  return { ...swr, presentations, presentationsLegacy: presentations as any as PresentationT[] };
}
